<form clrStepper [formGroup]="confirmationForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Kunde</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content>
      <clr-input-container>
        <label>Betreff</label>
        <input clrInput name="name_project" formControlName="name_project" />
      </clr-input-container>

      <clr-input-container>
        <label>Beschreibung</label>
        <input clrInput name="description" formControlName="description" />
      </clr-input-container>
      <clr-input-container>
        <label>Anfragenummer des Kunden</label>
        <input clrInput name="request_id" formControlName="request_id" />
      </clr-input-container>
      <clr-input-container>
        <label>Bestellnummer des Kunden</label>
        <input clrInput name="order_id" formControlName="order_id" />
      </clr-input-container>
      <clr-input-container>
        <label>Firma (Kunde)</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput name="street" formControlName="street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput name="city" formControlName="city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput name="postcode" formControlName="postcode" />
      </clr-input-container>
      <app-country-select controlName="country" label="Land" />
      <clr-select-container *ngIf="isUpdateMode">
        <label>Status</label>
        <select clrSelect formControlName="status">
          <option value="open">Entwurf</option>
          <option value="sent">Abgeschickt</option>
          <option value="confirmed">Bestätigt</option>
          <option value="revised">Überarbeitet</option>
          <option value="cancelled">Storniert</option>
        </select>
      </clr-select-container>
      <clr-date-container>
        <label>Datum</label>
        <input clrDate type="date" placeholder="{{ confirmationData?.job_date | date: 'dd.MM.yyyy' }}" formControlName="job_date" />
      </clr-date-container>
      <br />
      <clr-date-container>
        <label>Lieferdatum</label>
        <input clrDate type="date" placeholder="{{ confirmationData?.delivery_date | date: 'dd.MM.yyyy' }}" formControlName="delivery_date" />
      </clr-date-container>
      <br />
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/confirmation/details', projectId, jobId, confirmationId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input type="radio" clrRadio formControlName="employee_phm" [value]="employee.staff_id" />
          <label *ngIf="employee.staff_id !== projectStaff()">{{ employee.firstname }} {{ employee.lastname }}</label>
          <label *ngIf="employee.staff_id === projectStaff()" class="leader"><b>{{ employee.firstname }} {{ employee.lastname }}</b></label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br />
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/confirmation/details', projectId, jobId, confirmationId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Kunden - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <select clrSelect formControlName="employee_leader">
        <option></option>
        <option *ngFor="let person of persons" [ngValue]="person.pid">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <br />
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIV">
    <clr-step-title>Bedingungen</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <label>Angebotsbedingungen: </label>
      <select clrSelect formControlName="cond_offer">
        <option></option>
        <option *ngFor="let condI of offer_conditions" [ngValue]="condI.cond_id">{{ condI.name }}</option>
      </select>
      <br />
      <label>Lieferbedingungen: </label>
      <select clrSelect formControlName="cond_delivery">
        <option></option>
        <option *ngFor="let condII of delivery_conditions" [ngValue]="condII.cond_id">{{ condII.name }} ({{ condII.text }})</option>
      </select>
      <br />
      <label>Zahlungsbedingungen: </label>
      <select clrSelect formControlName="cond_payment">
        <option></option>
        <option *ngFor="let condIII of payment_conditions" [ngValue]="condIII.cond_id">{{ condIII.name }}</option>
      </select>
      <br />
      <clr-input-container>
        <label>Lieferzeit:</label>
        <input clrInput formControlName="delivery_remarks" />
      </clr-input-container>
      <br />
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" *ngIf="!selectedDeliveryHasOption" (click)="updateConfirmation()">Aktualisieren</button>
        <button class="btn" clrStepButton="next" *ngIf="selectedDeliveryHasOption">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/confirmation/details', projectId, jobId, confirmationId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel *ngIf="selectedDeliveryHasOption" formGroupName="stepV">
    <clr-step-title>Abweichende Lieferanschrift</clr-step-title>
    <clr-step-description>Lieferadresse (erscheint auf der Auftragsbestätigung)</clr-step-description>
    <clr-step-content>
      <clr-input-container>
        <label>Firma</label>
        <input clrInput formControlName="delivery_company" />
      </clr-input-container>
      <clr-input-container>
        <label>Abteilung</label>
        <input clrInput formControlName="delivery_department" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput formControlName="delivery_street" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput formControlName="delivery_postcode" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput formControlName="delivery_city" />
      </clr-input-container>
      <app-country-select controlName="delivery_country" label="Land" />
      <br />
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" (click)="updateConfirmation()">Aktualisieren</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/confirmation/details', projectId, jobId, confirmationId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>

<pre *ngIf="devMode" class="datepicker-output">
  {{ confirmationForm.value | json }}
</pre>
